import { Widget } from 'jamespot-front-business';
import { jCommentList, WidgetDisplayMode, WidgetWrapperProps } from 'jamespot-user-api';

import { useIntl } from 'react-intl';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import WidgetWrapperCore from '../widgets/WidgetWrapperCore';
import { CSSCommentsBlocWidgetWrapper } from './CommentsBloc.styles';

const JRCMessage = commonComponentsRegistry.getLazyComponent('Message');

export const CommentsBlocCommentWidgetsWrapper = (props: {
    comment: jCommentList;
    widgets: WidgetWrapperProps[];
    mode: WidgetDisplayMode;
    inplace: boolean;
    handleWidgetUpdate: () => void;
    handleWidgetRemove: () => void;
}) => {
    const intl = useIntl();
    const { widgets, comment, inplace, mode, handleWidgetUpdate } = props;
    const flushedWidgets = useAppSelector(Widget.selectors.selectFlushedWidgets, shallowEqual);

    return (
        <>
            {widgets
                .filter((el) => !flushedWidgets.includes(el.widget.uniqid))
                .map(
                    (widget) =>
                        widget && (
                            <CSSCommentsBlocWidgetWrapper key={widget.widget.uniqid}>
                                <WidgetWrapperCore
                                    uniqid={widget.widget.uniqid}
                                    widgetObject={comment}
                                    widget={widget}
                                    inplace={inplace}
                                    mode={mode}
                                    onWidgetUpdate={handleWidgetUpdate}
                                    cannotDisplayComponent={(widget) => {
                                        return (
                                            <JRCMessage
                                                variant={'info'}
                                                message={intl.formatMessage(
                                                    { id: 'WIDGET_Cannot_Display' },
                                                    { widget },
                                                )}
                                            />
                                        );
                                    }}
                                    context={'comment'}
                                />
                            </CSSCommentsBlocWidgetWrapper>
                        ),
                )}
        </>
    );
};
